<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "sveltestrap";
	import { v4 as uuidv4 } from 'uuid';
    import { Param } from "../Model/Param"
    import { kinshipsService, paramsService } from "../services"

	const dispatch = createEventDispatcher();

	export let kinship;

	kinship = {
        id: uuidv4(),
        kinship: uuidv4(),
        member: null,
        name: null
    }

	let param = {
		id: null,
		type: null,
		name: null
	};
	let size = 'xs';
	let open = false;

	const toggle = () => {
	  size = 'xs';
	  open = !open;
	};

  $: open = !!kinship;

	async function seeData() {
		let radio = document.querySelector('input[name="radio"]:checked').value
		kinship.member = radio;

		param.type = 'kinshipRelation'
		param.name = kinship.name;
		param.id = kinship.kinship;

		await paramsService.saveParam(new Param(param))

		const paramResponse = await paramsService.findOne(param.id)

		if (paramResponse) {
			const response = await kinshipsService.saveKinshipParam(kinship);

			if(response){
				open = false;
			}
		}

		location.reload();
	}

  </script>

  <style>

  </style>

  
	<Modal isOpen={open} {toggle} {size}>
	  <ModalHeader {toggle}>Añadir nueva relación</ModalHeader>
	  <ModalBody>
			<Label for='kinshipName'>Nombre</Label>
			<Input id='kinshipName' type='text' bind:value={kinship.name} />
			
			<Label for='kinshipMember'>Permite grupos</Label>
			<Input id='1' name='radio' type='radio' label='Si' value='1' />
			<Input id='0' name='radio' type='radio' label='No' value='0' />
	  </ModalBody>
	  <ModalFooter>
			<Button color="danger" >Eliminar</Button>
		<Button color="primary" on:click={seeData}>Guardar</Button>
	  </ModalFooter>
	</Modal>